import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PagamentoRealizado.css';

function PagamentoRealizado() {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.setItem('pagamentoRealizado', true);

    const timer = setTimeout(() => {
      navigate('/login');
    }, 5000); // Redireciona após 5 segundos

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <div className="payment-success-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="checkmark-icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h1 className="payment-success-title">
          Pagamento Realizado com Sucesso!
        </h1>
        <p className="payment-success-message">
          Obrigado por sua assinatura. Seu acesso ao plano foi ativado com
          sucesso.
        </p>
        <p className="payment-success-redirect">
          Você será redirecionado para o seu login em breve.
        </p>
      </div>
    </div>
  );
}

export default PagamentoRealizado;
